import React from "react";
import { Button as MuiButton, IconButton as MuiIconButton, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 6,
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  outlined: {
    borderColor: theme.palette.divider,
    "&:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor: "rgba(25, 118, 210, 0.04)",
    },
  },
  iconButton: {
    padding: theme.spacing(0.5),
    "& .MuiSvgIcon-root": {
      fontSize: "1.2rem",
    },
  },
  smallIcon: {
    padding: 4,
    "& .MuiSvgIcon-root": {
      fontSize: 14,
    },
  },
}));

// ------------------ UI Component ------------------ //
export const SKButton = ({ variant = "text", color = "primary", className = "", ...props }) => {
  const classes = useStyles();

  return (
    <MuiButton
      className={`${classes.root} ${className}`}
      variant={variant}
      color={color}
      {...props}
    />
  );
};

export const SKIconButton = ({ size = "medium", className = "", ...props }) => {
  const classes = useStyles();

  const iconButtonClasses = [classes.iconButton, size === "small" && classes.smallIcon, className]
    .filter(Boolean)
    .join(" ");

  return <MuiIconButton className={iconButtonClasses} {...props} />;
};

// ------------------ Domain Service Layer ------------------ //
export const SKExportButton = ({
  variant = "text",
  color = "primary",
  className = "",
  onExport,
  label = "Export",
  loadingLabel = "Generating...",
  ...props
}) => {
  const classes = useStyles();
  const [isGenerating, setIsGenerating] = React.useState(false);

  const handleClick = async (e) => {
    if (!onExport) return;

    try {
      setIsGenerating(true);
      await onExport(e);
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <SKButton
      className={`${classes.root} ${className}`}
      variant={variant}
      color={color}
      onClick={handleClick}
      disabled={isGenerating || props.disabled}
      {...props}
    >
      {isGenerating ? loadingLabel : label}
    </SKButton>
  );
};
